export const basic = () => import('@/layouts/Basic.vue')
export const clawPointDetail = () => import('@/views/ClawPointDetail.vue')
export const clawPointTask = () => import('@/views/ClawPointTask.vue')
export const service = () => import('@/views/Service.vue')
export const policy = () => import('@/views/Policy.vue')
export const invitation = () => import('@/views/Invitation.vue')
export const download = () => import('@/views/Download.vue')
// 活动页
export const ActivityTrip = () => import('@/views/ActivityTrip.vue')
export const ActivityFoods = () => import('@/views/ActivityFoods.vue')
//美食
export const foodDetail = () => import('@/views/FoodDetail.vue')
// ---
export const sceneryRank = () => import('@/views/SceneryRank.vue')
export const foodsRank = () => import('@/views/FoodsRank.vue')
//景点
export const sceneryDetail = () => import('@/views/SceneryDetail.vue')
//物品
export const goodDetail = () => import('@/views/GoodDetail.vue')
//纸条
export const paperDetail = () => import('@/views/PaperDetail.vue')
//errorPage
export const notFound = () => import('@/views/NotFound.vue')
